import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { FundFeatureConfig } from '../../../types/insurances/FundFeatureConfig';
import { fund as base } from './base';
import { fund as AT } from './AT';
import { fund as CZ } from './CZ';
import { fund as HU } from './HU';

export const fundConfig: InsuranceIndex<FundFeatureConfig> = { base, AT, CZ, HU };
